import { render, staticRenderFns } from "./query_experts.vue?vue&type=template&id=42b8e89a&scoped=true"
import script from "./query_experts.vue?vue&type=script&lang=js"
export * from "./query_experts.vue?vue&type=script&lang=js"
import style0 from "./query_experts.vue?vue&type=style&index=0&id=42b8e89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8e89a",
  null
  
)

export default component.exports